export default function modalCloseOnEscape(modalCloseId: string) {
  window.addEventListener("keyup", function (event) {
    if (event.key === "Escape") {
      const modalCloseButton = document.getElementById(modalCloseId)
      modalCloseButton && modalCloseButton.click()
    }
  })
}
